export const CREATE_PRJASN_START = 'CREATE_PRJASN_START';
export const CREATE_PRJASN_SUCCESS = 'CREATE_PRJASN_SUCCESS';
export const CREATE_PRJASN_FAILURE = 'CREATE_PRJASN_FAILURE';
export const CREATE_PRJASN = 'CREATE_PRJASN';

export const UPDATE_PRJASN_START = 'UPDATE_PRJASN_START';
export const UPDATE_PRJASN_SUCCESS = 'UPDATE_PRJASN_SUCCESS';
export const UPDATE_PRJASN_FAILURE = 'UPDATE_PRJASN_FAILURE';

export const FETCH_PRJASN_START  ='FETCH_PRJASN_START';
export const FETCH_PRJASN_SUCCESS ='FETCH_PRJASN_SUCCESS';
export const FETCH_PRJASN_FAILURE  ='FETCH_PRJASN_FAILURE';

export const FETCH_PRJ_START  ='FETCH_PRJ_START';
export const FETCH_PRJ_SUCCESS ='FETCH_PRJ_SUCCESS';
export const FETCH_PRJ_FAILURE  ='FETCH_PRJ_FAILURE';

export const SET_PRJASN_INIT  ='SET_PRJASN_INIT';
export const LOADING ='LOADING';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';
export const INIT = 'INIT';






